import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';
import { BaseComponent } from '../../../../shared/components/component-base';
import { ApiResponse, BaseApiResponse } from '../../../../shared/models/api-response.model';
import { AttachmentList } from '../../../../shared/models/attachment';
import { ProcessActivityEnum } from '../../../../shared/models/enums';
import { MainRequestDetailsDto } from '../../model/main-request-details.dto';
import { ProcessActionDto } from '../../model/process-action-dto';
import { SaveRequestDecisionDto } from '../../model/request-decision-dto';
import { WorkflowService } from '../../services/workflow-service';
import { TasksCountService } from '../../../../shared/services/tasks-count.service';
@Component({
  selector: 'app-request-decision',
  templateUrl: './request-decision.component.html',
})
export class RequestDecisionComponent extends BaseComponent {
  @Input() requestId: string;
  @Input() request: Observable<any>;
  attachmentList: AttachmentList[] = [];

  actions: ProcessActionDto[];
  selectedAction: string;
  isCommentRequired: boolean = false;
  saveRequestDecisionDto: SaveRequestDecisionDto = {} as SaveRequestDecisionDto;
  commentFile: File = null;
  isValidFile: boolean = true;
  isValidFileSize: boolean = true;
  commentAttachmentId?: string;
  commentAttachmentType?: string;
  commentAttachmentName?: string;
  processActivityEnum = ProcessActivityEnum;
  requestActivity: number;
  constructor(
    public _workflowService?: WorkflowService,
    private tasksCountService?: TasksCountService
  ) {
    super();
  }

  ngOnInit() {
    this.getRequestActions();
    this.getRequestDetails();
  }

  getRequestDetails() {
    if (this.requestId) {
      this._workflowService.getMainRequestDetails(this.requestId).subscribe({
        next: (res: ApiResponse<MainRequestDetailsDto>) => {
          this.requestActivity = res.value.processActivityId;
        }
      });
    }
  }

  getRequestActions() {
    this._workflowService.getRequestActions(this.requestId).subscribe({
      next: (res: ApiResponse<ProcessActionDto[]>) => {
        if (res.success) {
          this.actions = res.value;

          if (this.actions.length == 1) {
            this.selectedAction = this.actions[0].actionName;
          }
        }
      }
    });
  }

  onSelectedAction(evt) {
    const selectedValue = evt.target.value;
    const selectedActionObj = this.actions.find(action => action.actionName === selectedValue);
    
    if (selectedActionObj) {
      this.selectedAction = selectedActionObj.actionName;
      this.isCommentRequired = selectedActionObj.isCommentRequired || false;
    } else {
      this.selectedAction = "";
      this.isCommentRequired = false;
    }
  }

  saveRequestDecision(notes: string) {
    Swal.fire({
      text: this.translate.instant('workflow.sendRequestConfirm'),
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#0ab39c',

      cancelButtonText: this.translate.instant('common.cancel'),
      confirmButtonText: this.translate.instant('common.yes'),
      customClass: {
        cancelButton: 'btn btn-light',
        confirmButton: 'submit btn btn--primary',
      },

    }).then((result) => {
      if (result.isConfirmed) {
        if (
          !result.isConfirmed ||
          !this.selectedAction ||
          (this.isCommentRequired && notes?.trim()?.length < 1)
        )
          return;

        this.saveRequestDecisionDto.baseRequestId = this.requestId;
        this.saveRequestDecisionDto.comment = notes;
        this.saveRequestDecisionDto.actionName = this.selectedAction;
        this.saveRequestDecisionDto.commentAttachmentId = this.commentAttachmentId;
        this._workflowService
          .saveRequestDecision(this.saveRequestDecisionDto).subscribe(
            (result: BaseApiResponse) => {
              if (result.success) {
                this.toastrService.success( this.translate.instant('workflow.requestSent'));

                // Refresh tasks count before navigation
                this.tasksCountService.refreshTasksCount();

                this._router.navigate(['/workflow/inbox']);
              } else {
                this.toastrService.error(result.message, "");
              }
            },
            (err: Error) => {
              console.error(`error caught in component:${err.message}`);
            }
          );
      }
    })
  }

  onCommentAttachmentChange(event: File) {
    this.isValidFile = true;
    this.isValidFileSize = true;
    this.commentFile = event;

    if (!this.checkAcceptedFileTypes(this.commentFile)) {
      this.isValidFile = false;
      return;
    }

    if (this.commentFile.type.substr(0, 5) != 'image' && this.commentFile.type != "application/pdf")
      this.isValidFile = false;

    this.AddAttachment();
  }

  checkAcceptedFileTypes(file: File,): boolean {
    let extensions = ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png'];
    let fileExtension = file.name.split('.').pop() || '';
    return extensions.indexOf(fileExtension) >= 0;
  }

  AddAttachment() {

    if (this.commentFile) {
      if (this.commentFile.size / 1024 > 5000) {
        this.isValidFileSize = false;
        return;
      }
    }
    this.commentAttachmentName = this.commentFile.name;
    const extension = this.commentFile.name.split('.').pop();
    this.commentAttachmentType = extension && extension !== this.commentFile.name ? extension : null;

    this._workflowService.addRequestAttachments(this.requestId, this.commentFile).subscribe({
      next: (res: any) => {
        if (res.success != null) {
          this.fillAttachment(this.requestId);
        }
        else
          this.toastrService.error(res.message, "");
      },
    });
  }

  fillAttachment(requestId) {

    this._workflowService.getRequestAttachments(requestId).subscribe({
      next: (res) => {

        if (res && res.success) {
          let attachments = res.value;
          this.attachmentList = [];

          for (var i = 0; i < attachments.length; i++) {
            let addedAttach: AttachmentList = {
              id: attachments[i].id,
              entityAttachmentId: attachments[i].id,
              title: attachments[i].fileName,
              description: attachments[i].description,
              filePath: attachments[i].filePath,
              fileSize: attachments[i].fileSize,
              extension: attachments[i].extension
            };
            let contentType = attachments[i].contentType;
            if (contentType.substr(0, 5) == 'image') {
              //let imgType = contentType.substr(contentType.indexOf('/') + 1, contentType.length);
              addedAttach.fileType = 'image';
            } else if (contentType == "application/vnd.openxmlformats-officedocument.wordprocessingml.document")
              addedAttach.fileType = "word";
            else if (contentType == "application/pdf")
              addedAttach.fileType = "pdf";

            this.attachmentList.push(addedAttach);
          }


        }
        else if (res && !res.success) {
          this.toastrService.error(res[0].message, "");
        }
        else {
          this.toastrService.error(this.translate.instant('common.errorOccured'), "");
        }
      },
      error: (err: Error) => {
        this.toastrService.error(err.message, "");

      }
    });
  }

  downloadFile(attachmentId: string) {
    this.attachementService.get(attachmentId)
      .subscribe({
        next: async (res: any) => {
          if (res != null) {
            let attach = res.value;
            if (attach.fileContent) {
              const base64File = attach.fileContent;
              const base64Response = await fetch(`data:` + attach.contentType + `;base64,${base64File}`);
              const blob = base64Response.blob();
              const url = window.URL.createObjectURL(await blob);
              window.open(url, "_blank");
            }
          }
        },
        error: (error: Error) => console.log(error.message)
      });
  }

  deleteRequestAttachment(attachmentId: string) {

    Swal.fire({
      text: this.translate.instant('common.deleteFileConfirmation'),
      icon: 'question',
      iconHtml: '<img src="/assets/images/delete.png" style="width:100%"/>',
      showCancelButton: true,
      confirmButtonColor: '#d33',

      cancelButtonText: this.translate.instant('common.cancel'),
      confirmButtonText: this.translate.instant('common.yes'),
      customClass: {
        cancelButton: 'btn btn--primary-outline',
        confirmButton: 'submit btn btn--primary',
      },

    }).then((result) => {
      if (result.isConfirmed) {
        this._workflowService.deleteRequestAttachment(attachmentId).subscribe(
          (data) => {
            if (data.success) {
              this.fillAttachment(this.requestId);
            }
          },
          (err) => {
            this.toastrService.error(
              err, "");
          }
        );

      }
    })
  }
}

